import { useLayoutEffect } from 'react'
import { ThemeProvider } from '@mui/material/styles'
import { useBehaviorObservable } from '@/common/react/observable-hooks'
import { type CssThemeService } from './CssThemeService'
import { useDiRef } from '@/common/react/di-hooks'

interface AppThemeProviderProps {
  children: React.ReactNode
}

export function AppThemeProvider({ children }: AppThemeProviderProps) {
  const themeService = useDiRef<CssThemeService>('CssThemeService')
  const theme = useBehaviorObservable(themeService.theme$)

  useLayoutEffect(() => {
    document.documentElement.style.backgroundColor = theme.palette.background.default
    document.body.style.backgroundColor = theme.palette.background.default
  }, [theme])

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>
}

// export function NoDiAppThemeProvider({ children }: AppThemeProviderProps) {
//   return <ThemeProvider theme={lightTheme}>{children}</ThemeProvider>
// }
